<!-- display the quiz name and the questions and options-->
<nz-card *ngIf="quiz" class="quiz-card">
    <h1>{{ quiz.name }}</h1>
    <div *ngIf="quiz.video_url && videoUrl" class="quiz-video">
        <video width="100%" controls playsinline preload="metadata" controlsList="nodownload" [src]="videoUrl"
            (error)="onVideoError($event)">
            Your browser does not support the video tag.
        </video>
        <a class="video-fallback" [href]="videoUrl" target="_blank" rel="noreferrer">Open video in a new tab</a>
    </div>
    <form [formGroup]="quizForm">
        <div formArrayName="questions" class="quiz-questions">
            <div *ngFor="let question of questionsFormArray.controls; let i = index" [formGroupName]="i"
                class="quiz-question">
                <h2>{{ question.get('question')?.value }}</h2>
                <nz-radio-group formControlName="answer">
                    <label nz-radio *ngFor="let option of quiz.questions[i]?.options" [nzValue]="option">
                        {{ option }}
                    </label>
                </nz-radio-group>
            </div>
        </div>
        <div class="quiz-actions">
            <button nz-button nzType="default" type="button" (click)="backToOnboarding()">Back to Onboarding</button>
            <button nz-button nzType="primary" type="button" (click)="submitQuiz()">Submit</button>
        </div>
    </form>
</nz-card>
